import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const addI18n = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/i18n'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

export const getI18n = async ({
	params = {},
	body = {},
	query = {
		tableName: '',
		tableId: '',
		menuId: '',
	},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/i18n'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getI18nById = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/i18n/${params.id}`
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateI18n = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/i18n/${params.id}`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

export const deleteI18n = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/i18n/${params.id}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const i18nApi = {
	addI18n: addI18n,
	getI18n: getI18n,
	getI18nById: getI18nById,
	updateI18n: updateI18n,
	deleteI18n: deleteI18n,
}

export default i18nApi
